import React from 'react';
import { AdvancedMarker, AdvancedMarkerAnchorPoint, Map } from '@vis.gl/react-google-maps';

type Props = {
    lat: number, long: number,
    label?: string
}

export function GoogleMap({ lat, long, label }: Props) {
    const position = { lat, lng: long };

    return (
        <Map
            defaultCenter={position}
            defaultZoom={15}
            disableDefaultUI={true}
            mapId="63a42379136971b6"
        >
            <AdvancedMarker position={position} />
            {label &&
                <AdvancedMarker position={position} anchorPoint={AdvancedMarkerAnchorPoint.LEFT_BOTTOM}>
                    <div className='font-sans text-base font-semibold left-full text-left text-gray-600 pl-4 py-2 [text-shadow:_0_1px_0_var(--tw-shadow-color)] shadow-white'>{label}</div>
                </AdvancedMarker>
            }
        </Map>
    );
}